import { GoalBreakpointOption } from '@naturalcycles/shared'
import { DatoCmsFileField } from '@src/typings/dato-cms-assets'
import type { ReactNode } from 'react'
import { NcImage } from '../nc-image/NcImage.component'
import { QuizButton } from '../quiz-button/QuizButton.component'
import styles from './QuizIntro.module.scss'

export interface QuizIntroProps {
  title: string
  subTitle: string
  imageText: string
  image: DatoCmsFileField
  buttonTexts: {
    text: {
      text: string
    }
    goalNumber: {
      goalNumber: number
    }
    icon: Pick<DatoCmsFileField, 'url'>
  }[]
  utmSourceWeb: string
}

export function QuizIntro({
  title,
  subTitle,
  image,
  buttonTexts,
  imageText,
  utmSourceWeb,
}: QuizIntroProps): ReactNode {
  return (
    <section className={styles.QuizIntro}>
      <div className={styles.QuizIntro__section}>
        <div className={styles.QuizIntro__imageWrapper}>
          <NcImage className={styles.QuizIntro__image} {...image} />
          <div className={styles.QuizIntro__imageText}>{imageText}</div>
        </div>
        <div className={styles.QuizIntro__content}>
          <p className={styles.QuizIntro__subTitle}>{subTitle}</p>
          <h3 className={styles.QuizIntro__heading}>{title}</h3>
          <div className={styles.QuizIntro__buttons}>
            {buttonTexts.map(({ text: { text }, goalNumber: { goalNumber }, icon: { url } }) => (
              <QuizButton
                text={text}
                goalNumber={goalNumber as GoalBreakpointOption}
                iconUrl={url}
                utmSourceWeb={utmSourceWeb}
                key={goalNumber}
              />
            ))}
          </div>
          <div className={styles.QuizIntro__progressWrapper}>
            <div className={styles.QuizIntro__progress} />
          </div>
        </div>
      </div>
    </section>
  )
}
